import styled from 'styled-components'

export const DocumentsModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 420px;

  h1 {
    color: var(--brand-primary, #748351);
    margin-bottom: 0.5rem;
  }

  p {
    font-weight: 300;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 1.5rem;
  }
`

export const DocumentsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
`

export const DocumentCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  padding: 1rem;
  border: 1px solid var(--brand-primary, #748351);
  border-radius: 0.5rem;
`

export const DocumentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  > span {
    font-weight: 700;
    color: var(--brand-primary, #748351);
  }
`

export const VerificationCode = styled.span`
  display: flex;
  align-items: center;
  gap: 0.4rem;

  font-size: 0.85rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    background: none;
    border: none;
    cursor: pointer;
    color: var(--brand-primary, #748351);
    padding: 0;
  }
`

export const VerificationNote = styled.span`
  font-size: 0.75rem;
  color: #6d6d6d;

  a {
    color: var(--brand-primary, #748351);
    text-decoration: underline;
  }
`
